import { SectionLabel, Reveal } from "./shared";

const BELIEFS = [
  "\u201CI already used my VA benefit once, so I'm probably out of options.\u201D",
  "\u201CEvery lender runs the same numbers, so all I really need is the lowest rate.\u201D",
  "\u201CA lender already said no, so there's nothing left to look at.\u201D",
];

export default function Letter() {
  return (
    <section className="py-24 lg:py-36 px-6 bg-white/[0.015]" data-testid="letter-section">
      <div className="max-w-[760px] mx-auto">
        <Reveal>
          <SectionLabel n="002" text="A PERSONAL NOTE" />
          <p className="text-white/60 text-lg mb-10">If you're planning a VA-backed purchase,</p>
          <p className="text-white/70 leading-relaxed mb-8">
            there's a good chance at least one of these thoughts has crossed your mind:
          </p>
        </Reveal>
        <div className="space-y-4 mb-10">
          {BELIEFS.map((b, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div
                className="flex gap-4 p-5 border"
                style={{ background: "rgba(255,0,0,0.04)", borderColor: "rgba(255,0,0,0.1)" }}
                data-testid={`false-belief-card-${i + 1}`}
              >
                <span className="text-red-400 font-bold shrink-0">✗</span>
                <p className="text-white/75 italic text-[15px] leading-relaxed">{b}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <div className="h-px bg-[#0162CA] w-24 mb-10" />
          <div className="space-y-6 text-white/65 leading-[1.8] text-[15px]">
            <p>
              Here's what I've learned after 20+ years in and around the mortgage industry: each of those beliefs is
              usually an education gap, not a verdict. Using VA-backed financing before does not automatically end
              the conversation — remaining entitlement is a real question worth actually asking, not assuming.
            </p>
            <p>
              And two quotes assembled on different assumptions are not comparable, no matter how confident the
              lower number looks. A previous "no" is worth understanding before it's accepted, because sometimes the
              structure of the deal — not the file — was the thing that was never examined.
            </p>
            <p>
              To be clear: only a full review of your individual information can answer your specific situation, and
              nothing in this class promises approval or eligibility. Sometimes the responsible answer is "prepare
              and wait" — and that's a legitimate outcome of this class too. What I can promise is that you'll leave
              understanding how the whole transaction fits together, so whatever your next step is, you'll choose it
              on purpose.
            </p>
          </div>
          <p className="mt-10 text-[#0162CA] font-semibold">
            — Josh Bartlett, Branch Manager, Shoreline Mortgage Group
          </p>
        </Reveal>
      </div>
    </section>
  );
}
